<template>
  <div class="row mt-3">
    <div class="col-md-9 mt-1">
      <dara-p size="md">
        <b>{{ $t('email') }}:</b> {{ user.email }}
      </dara-p>
    </div>
    <div class="col-md-9 mt-1">
      <dara-p size="md">
        <b>{{ $t('position') }}:</b> {{ user.position }}
      </dara-p>
    </div>
    <!-- <div class="col-md-9 mt-1">
      <dara-p size="md">
        <b>{{ $t('gender') }}:</b> <span v-if="user.gender !== 'Other'">{{ $t(user.gender.toLowerCase()) }}</span>
        <small v-else class="text-muted"> {{ $t('not-specified') }}</small>
      </dara-p>
    </div> -->
    <div class="col-md-9 mt-1">
      <dara-p size="md">
        <b>{{ $t('birthday') }}:</b> {{ formatDate(user.birthday, 'DD/MM/YYYY') }}
        <small v-if="!user.birthday" class="text-muted">{{ $t('not-specified') }}</small>
      </dara-p>
    </div>
    <div class="col-md-9 mt-1">
      <dara-p size="md">
        <b>{{ $t('city') }}:</b> {{ user.city }}
        <small v-if="!user.city" class="text-muted"> {{ $t('not-specified') }}</small>
      </dara-p>
    </div>
    <div class="col-md-9 mt-1">
      <dara-p size="md">
        <b>{{ $t('state') }}:</b> {{ states[user.state] }}
        <small v-if="!user.state" class="text-muted">{{ $t('not-specified') }}</small>
      </dara-p>
    </div>
    <div class="col-md-9 mt-1">
      <dara-p size="md">
        <b>{{ $t('country') }}:</b> {{ $t(user.country) }}
        <small v-if="!user.country" class="text-muted"> {{ $t('not-specified') }}</small>
      </dara-p>
    </div>
    <div class="col-md-9 mt-1">
      <dara-p size="md">
        <b>{{ $t('department') }}:</b> {{ department }}
        <small v-if="!department" class="text-muted"> {{ $t('not-specified') }}</small>
      </dara-p>
    </div>
  </div>
</template>

<script>
import { BRAZIL_TRANSLATIONS, CANADA_TRANSLATIONS, UNITED_STATES_TRANSLATIONS } from '@/assets/resources/state-country';
import { formatDate, formatToTimeAgo } from '@/helpers/date';
import { getDepartmentById } from '@/modules/department/department.service';

export default {
  name: 'DaraUserViewInformation',
  props: {
    user: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      department: null,
      states: null,
    };
  },
  created() {
    this.fetchDepartment();
    this.mountState();
  },
  methods: {
    formatDate,
    formatToTimeAgo,
    fetchDepartment() {
      if (this.user.department_id) {
        getDepartmentById(this.user.department_id)
          .then(data => {
            this.department = data.name;
          });
      }
    },
    mountState() {
      if (this.user.country === 'brazil') {
        this.states = BRAZIL_TRANSLATIONS;
      } else if (this.user.country === 'canada') {
        this.states = CANADA_TRANSLATIONS;
      } else {
        this.states = UNITED_STATES_TRANSLATIONS;
      }
    },
  },
};
</script>
